import { ComponentProps, cloneElement, ReactElement } from 'react';
import clsx from 'clsx';

import { BlurbCard } from 'new-components/BlurbCard/BlurbCard';
import { OpPage } from 'new-components/OpPage/OpPage';

import './OpBlurbPage.scss';

export const OpBlurbPage = (
  props: Omit<ComponentProps<typeof BlurbCard>, 'avatar'> & {
    avatarComponent?: ReactElement;
  },
) => {
  const enhancedAvatar = props.avatarComponent
    ? cloneElement(
        props.avatarComponent as ReactElement<{ className?: string }>,
        {
          className: clsx(
            'op-blurb-page__card-avatar-icon',
            (props.avatarComponent?.props as { className?: string }).className,
          ),
        },
      )
    : null;

  return (
    <OpPage className="op-blurb-page">
      <BlurbCard
        classes={{ ...props.classes, avatar: 'op-blurb-page__card-avatar' }}
        avatar={enhancedAvatar}
        {...props}
      />
    </OpPage>
  );
};
